const Error = ({ text, message }) => {
    return (
        <div className="p-2 border border-red-500 w-fit rounded">
            <h4>{text ? text : 'Qualcosa è andato storto.'}</h4>
            <h5>{message}</h5>
        </div>
    )
}

export default Error;